// extracted by mini-css-extract-plugin
module.exports = {"commentList__thread":"bx_jw","commentList__list":"bx_jx"};